<nb-card [@dialog] [nbSpinner]="loading" nbSpinnerStatus="primary" nbSpinnerSize="giant">
    <nb-card-header>Select Location
        <button nbButton ghost size="tiny" class="float-right" (click)="selectLocation(null)"><i class="fa fa-times"></i></button></nb-card-header>
    <nb-card-body>
        <nb-list>
            <nb-list-item *ngFor="let loc of models$ | async" [class.active]="loc.id === activeLoc" class="d-block" (click)="selectLocation(loc)">
                <h6 class="mb-3">{{loc.name}}
                    <span *ngIf="loc.user_id === userID" class="badge badge-primary float-right ml-2">Owner</span>
                    <span *ngIf="loc.user_id !== userID" class="badge badge-warning float-right">Shared</span>
                </h6>
                <p class="mb-1">{{loc.address}}</p>
                <p class="mb-1">{{loc.address_2}}</p>
                <p class="mb-1">{{loc.city}}</p>
                <div class="row mt-2" *ngIf="(loc.installation === 'DONE' || loc.installation === 'METER_ENTERED') else needInstall">
                    <div class="col-6">
                        <span *ngIf="loc.bridge?.connected">
                            <img src="assets/img/br-connected.png">
                            Bridge Online
                        </span>
                        <span *ngIf="!loc.bridge?.connected">
                            <img src="assets/img/offline.png">
                            Bridge Offline
                        </span>
                    </div>
                    <div class="col-6">
                        <span *ngIf="loc.ws?.connected && loc.ws?.battery_level !== 'low'">
                            <img src="assets/img/ws-connected.png">
                            Sensor Online
                        </span>
                        <span *ngIf="!loc.ws?.connected">
                            <img src="assets/img/offline.png">
                            Sensor Offline
                        </span>
                        <span *ngIf="loc.ws?.connected && loc.ws?.battery_level === 'low'">
                            <img src="assets/img/ws-low-battery.png">
                            Low Battery
                        </span>
                    </div>
                </div>
                <ng-template #needInstall>
                    <p class="pt-3 mb-0 text-center text-warning">Installation In Progress</p>
                    <p class="mb-0 text-center">Please finish installation with the Flume mobile app.</p>
                </ng-template>
            </nb-list-item>
            <nb-list-item *ngIf="!loading" class="d-block">
                <h6 class="text-center text-muted"><i class="fa fa-plus"></i> Add Device</h6>
                <p class="text-center text-muted">Adding another device requires the use of the iOS/Android app.</p>
                <p class="text-center text-muted">Please use the app to install your new device.</p>
            </nb-list-item>
        </nb-list>
    </nb-card-body>
</nb-card>